<section class="w-full h-full flex flex-col justify-between items-center py-6 overflow-auto">
  <span class="w-full icon text-base dismiss-regular text-gray-400 text-end pl-5" (click)="dialogRef.close()"></span>

    <div class="flex-grow w-full block content-center justify-center items-start px-14" #screenshot>
      <ng-container *ngComponentOutlet="component; injector: componentInjector"></ng-container>
    </div>
  
    <div class="w-full px-5">
      <button class="w-full justify-center btn-xs btn-green-flat rounded-lg" (click)="share()">
        اشتراک‌گذاری
      </button>
    </div>
  </section>
  